module.exports = __webpack_public_path__ + "img/stock1.3ec18996.png";